module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/BelowDeckMed_S4.496d003.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/BelowDeckMed_S4.jpg
// module id = OIFp
// module chunks = 0